import { z } from "zod";

import { opaqueIdSchema } from "../shared/identifier";

const sessionUserSchema = z
  .object({
    id: opaqueIdSchema,
    name: z.string().trim().min(1).max(160),
    email: z.email().max(254),
  })
  .strict();

const anonymousSessionSchema = z
  .object({
    authenticated: z.literal(false),
    user: z.null(),
    expires_at: z.null(),
  })
  .strict();

const authenticatedSessionSchema = z
  .object({
    authenticated: z.literal(true),
    user: sessionUserSchema,
    expires_at: z.iso.datetime({ offset: true }),
  })
  .strict();

export const sessionSchema = z.discriminatedUnion("authenticated", [
  anonymousSessionSchema,
  authenticatedSessionSchema,
]);

export type Session = z.infer<typeof sessionSchema>;
